import { render, staticRenderFns } from "./webIndex.vue?vue&type=template&id=3be4321e&scoped=true&"
import script from "./webIndex.vue?vue&type=script&lang=js&"
export * from "./webIndex.vue?vue&type=script&lang=js&"
import style0 from "./webIndex.vue?vue&type=style&index=0&id=3be4321e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4321e",
  null
  
)

export default component.exports